import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserInfo, UserRole } from 'src/app/model/User';
import { ModalConfig } from '../../controls/modal/modal-config';
import { ModalRef } from '../../controls/modal/modal-ref';
import { UserFormMode, UserFormTab, UserFormType } from '../../user-form/user-form.component';
import { UserService } from 'src/app/service/user.service';
import { catchError, of, tap } from 'rxjs';
import { Utils } from 'src/app/utils';
import { EventService } from 'src/app/service/event.service';
import { Events } from 'src/app/service/websocket.service';

export enum UserSaveResultType {
  CANCEL,
  SUCCESS,
  FAILURE
}

export class UserSaveResult {
  type: UserSaveResultType;
  form: FormGroup;
}

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
    standalone: false
})
export class UserComponent implements OnInit {
  //input
  currentUserAuthInfo:UserInfo;
  formType:UserFormType = UserFormType.LOCAL;
  formMode:UserFormMode = UserFormMode.ADD;
  formHeight:string = '';
  

  UserFormTab = UserFormTab;
  UserFormMode = UserFormMode;
  userForm:FormGroup = new FormGroup({});
  title:string = '';
  primaryButton:string = '';
  primaryButtonId:string = '';
  result:UserSaveResult = {type: UserSaveResultType.CANCEL, form: this.userForm};
  
  constructor(private modalRef: ModalRef,
              public modalConfig: ModalConfig,
              private userSrv: UserService,
              private eventService: EventService) { }

  ngOnInit(): void {
    this.currentUserAuthInfo = this.modalConfig.data.currentUserAuthInfo;
    this.formMode = this.currentUserAuthInfo ? UserFormMode.EDIT : UserFormMode.ADD;
    this.formType = this.modalConfig.data.formType;
    this.primaryButton = this.formMode == UserFormMode.EDIT ? $localize`Save` : $localize`Add`;
    this.primaryButtonId = this.formMode == UserFormMode.EDIT ? "user-save-btn" : "user-add-btn";
    this.title = this.formMode == UserFormMode.EDIT ? $localize`Edit user` : $localize`Add user`;
    this.formHeight = this.modalConfig.data.formHeight;
  }

  updateUserForm(userForm:FormGroup): void {
    this.userForm = userForm;
  }

  submit(): void {
    if(this.formMode == UserFormMode.EDIT){
      this.saveUser();
    }else if(this.formMode == UserFormMode.ADD){
      this.addUser();
    }
  }

  cancel(): void {
    this.result.form = this.userForm;
    this.result.type = UserSaveResultType.CANCEL;
    this.modalRef.close(this.result);
  }

  addUser():void {
    const envList:number[] = [];
    const solList:string[] = [];
    const role:string = this.userForm.get('userRoleCtrl').value;

    if(role === UserRole.SOLUTION_MANAGER.toString()){
      if(this.userForm.get('dataCtrl').value){
        this.userForm.get('dataCtrl').value.forEach(sol => {
          solList.push(sol.name);
        });
      }
    }else if(role === UserRole.ENVIRONMENT_MANAGER.toString()){
      if(this.userForm.get('dataCtrl').value){
        this.userForm.get('dataCtrl').value.forEach(env => {
          envList.push(env.id);
        });
      }
    }

    this.userSrv.createUser(this.userForm.get('userNameCtrl').value, //userName
                                this.userForm.get('givenNameCtrl').value, //firstName
                                this.userForm.get('surNameCtrl').value,   //lastName
                                this.userForm.get('newPasswordCtrl') ? this.userForm.get('newPasswordCtrl').value : '', //newUserPassword
                                this.userForm.get('confirmNewPasswordCtrl') ? this.userForm.get('confirmNewPasswordCtrl').value : '', //confirmNewPasswordCtrl
                                role, //role
                                envList,
                                solList).pipe(tap(resp => {
                                  if(resp){
                                    this.result.form = this.userForm;
                                    this.result.type = UserSaveResultType.SUCCESS;
                                    this.modalRef.close(this.result);
                                  }
                                }),
                                  catchError(resp => {
                                    this.result.form = this.userForm;
                                    this.result.type = UserSaveResultType.FAILURE;
                                    Utils.addHeaderMessageEventBanner(this.eventService, Events.ErrorMsg, $localize`Unable to create the user. Please verify the information and try again.`);
                                    return of(resp);
                                  })
                                ).subscribe();
  }

  saveUser():void {
    let envList:number[];
    let solList:string[];
    const role:string = this.userForm.get('userRoleCtrl').value;

    if(role === UserRole.SOLUTION_MANAGER.toString()){
      if(this.userForm.get('dataCtrl').value){
        solList = [];
        this.userForm.get('dataCtrl').value.forEach(sol => {
          solList.push(sol.name);
        });
      }
    }else if(role === UserRole.ENVIRONMENT_MANAGER.toString()){
      if(this.userForm.get('dataCtrl').value){
        envList = [];
        this.userForm.get('dataCtrl').value.forEach(env => {
          envList.push(env.id);
        });
      }
    }

    this.userSrv.updateUser(this.userForm.get('userNameCtrl').value, //newUserName
                                this.currentUserAuthInfo.userName,      //userName
                                this.userForm.get('givenNameCtrl').value, //firstName
                                this.userForm.get('surNameCtrl').value,   //lastName
                                this.userForm.get('newPasswordCtrl') ? this.userForm.get('newPasswordCtrl').value : '', //newUserPassword
                                role, //role
                                envList,
                                solList,
                                this.currentUserAuthInfo.userId).pipe(tap(resp => {
                                  if(resp){
                                    this.result.form = this.userForm;
                                    this.result.type = UserSaveResultType.SUCCESS;
                                    this.modalRef.close(this.result);
                                  }
                                }),
                                  catchError(resp => {
                                    this.result.form = this.userForm;
                                    this.result.type = UserSaveResultType.FAILURE;
                                    this.modalRef.close(this.result);
                                    return of(resp);
                                  })
                                ).subscribe();
  }
}